import React from 'react';

// Adım: "Searching & Matching" — son kullanıcının aksiyonu yoktur. Onboarding
// ekibinin yapacağı arama/tarama + otomatik eşleştirme sürecini anlatan
// bilgilendirme ekranı. mailto ile destek adresi içerir.
const SearchMatchInfoStep = ({t}) => {
    const bullet = (icon, color, text) => (
        <div style={{display: 'flex', gap: 14, alignItems: 'flex-start', marginBottom: 18}}>
            <span style={{width: 40, height: 40, borderRadius: 10, background: `${color}1a`, color: color,
                          flexShrink: 0, display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                <i className={icon} style={{fontSize: '1.25rem'}}/>
            </span>
            <div style={{color: '#374151', fontSize: '1.05rem', lineHeight: 1.55, paddingTop: 6}}>{text}</div>
        </div>
    );

    return (
        <div>
            <h2 style={{marginTop: 0, display: 'flex', alignItems: 'center', gap: 10}}>
                <i className="pi pi-search"/> {t('wizard.searchMatch.title')}
            </h2>
            <p style={{color: '#6b7280', maxWidth: 720, fontSize: '1.05rem', lineHeight: 1.55}}>
                {t('wizard.searchMatch.intro')}
            </p>

            <div style={{marginTop: 22, maxWidth: 760}}>
                {bullet('pi pi-clock', '#2563eb', t('wizard.searchMatch.scan'))}
                {bullet('pi pi-link', '#7c3aed', t('wizard.searchMatch.codes'))}
                {bullet('pi pi-calendar', '#0891b2', t('wizard.searchMatch.duration'))}
                {bullet('pi pi-user-plus', '#16a34a', t('wizard.searchMatch.manual'))}
                {bullet('pi pi-phone', '#d97706', t('wizard.searchMatch.contact'))}
            </div>

            <div style={{marginTop: 8, padding: '16px 18px', background: '#f9fafb', border: '1px solid #eee',
                         borderRadius: 10, color: '#374151', fontSize: '1.02rem', maxWidth: 760}}>
                {t('wizard.searchMatch.help')}{' '}
                <a href="mailto:onboarding@pricerest.com" style={{color: '#2563eb', fontWeight: 600}}>
                    onboarding@pricerest.com
                </a>
            </div>
        </div>
    );
};

export default SearchMatchInfoStep;
